import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { cancelarMiPlan, reanudarMiPlan } from '../services/membresiaService';

const fecha = (f) => (f ? new Date(f).toLocaleDateString('es-HN', { day: 'numeric', month: 'long', year: 'numeric' }) : '');
const MOTIVOS = ['Es muy caro para mí', 'No lo estoy usando lo suficiente', 'Me falta una función que necesito', 'Es difícil de usar', 'Cerré o pausé mi negocio', 'Me cambio a otra aplicación', 'Otro motivo'];

// "Cancelar mi plan" dentro de Mi plan: solo con un plan pagado activo.
// Cancelar = no renovar; el plan sigue hasta la fecha pagada.
export default function CancelarPlan() {
  const { suscripcion, recargarSuscripcion } = useAuth();
  const { mostrarToast } = useToast();
  const [abierto, setAbierto] = useState(false);
  const [motivo, setMotivo] = useState('');
  const [detalle, setDetalle] = useState('');
  const [guardando, setGuardando] = useState(false);

  if (suscripcion?.estado !== 'activa') return null;
  const hasta = fecha(suscripcion.pagado_hasta);

  const cancelar = async () => {
    setGuardando(true);
    try {
      await cancelarMiPlan([motivo, detalle.trim()].filter(Boolean).join(' · '));
      await recargarSuscripcion();
      setAbierto(false);
      mostrarToast(`Listo. Tu plan no se renovará y sigue activo hasta el ${hasta}.`, 'exito', 7000);
    } catch (e) { mostrarToast(e.message, 'error'); }
    setGuardando(false);
  };

  const reanudar = async () => {
    setGuardando(true);
    try {
      await reanudarMiPlan();
      await recargarSuscripcion();
      mostrarToast('¡Qué bueno que sigues con nosotros! 💜 Tu plan se renovará normalmente.', 'exito', 6000);
    } catch (e) { mostrarToast(e.message, 'error'); }
    setGuardando(false);
  };

  const caja = { padding: '16px', marginTop: '18px' };
  const btn = { border: '1px solid #E5E7EB', background: '#fff', borderRadius: '10px', padding: '10px 14px', fontWeight: 700, fontFamily: 'inherit', fontSize: '14px', cursor: guardando ? 'wait' : 'pointer' };

  if (suscripcion.renovacion_cancelada) {
    return (
      <div className="k-card" style={{ ...caja, background: '#FFFBEB', border: '1px solid #FCD34D' }}>
        <b>Cancelaste la renovación de tu plan</b>
        <p style={{ margin: '6px 0 12px', fontSize: '14px', color: '#374151' }}>
          Sigues con todas tus funciones hasta el <b>{hasta}</b>. Después tu cuenta queda en pausa (sin borrar nada) hasta que elijas un plan de nuevo.
        </p>
        <button onClick={reanudar} disabled={guardando} style={{ ...btn, background: 'var(--color-primario,#6D28D9)', color: '#fff', border: 'none' }}>
          {guardando ? 'Un momento…' : 'Seguir con mi plan'}
        </button>
      </div>
    );
  }

  if (!abierto) {
    return (
      <div style={{ textAlign: 'center', marginTop: '22px' }}>
        <button onClick={() => setAbierto(true)} style={{ background: 'none', border: 'none', color: '#6B7280', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit', fontSize: '13px' }}>
          Cancelar mi plan
        </button>
      </div>
    );
  }

  return (
    <div className="k-card" style={{ ...caja, border: '1px solid #FCA5A5' }}>
      <b style={{ fontSize: '16px' }}>¿Seguro que quieres cancelar tu plan?</b>
      <ul style={{ margin: '8px 0 12px', paddingLeft: '18px', fontSize: '14px', color: '#374151', display: 'grid', gap: '4px' }}>
        <li>No se te vuelve a cobrar. Sigues usando Kontrol hasta el <b>{hasta}</b>.</li>
        <li>Después tu cuenta queda en pausa: puedes ver tu información, pero no registrar ventas ni cambios. <b>No se borra nada.</b></li>
        <li>Puedes volver cuando quieras y encontrarás todo como lo dejaste.</li>
        {suscripcion.precio_fundador && <li style={{ color: '#B91C1C' }}><b>Pierdes tu precio fundador.</b> Si vuelves después, pagarás el precio vigente.</li>}
      </ul>
      <label htmlFor="motivo-cancelar" style={{ display: 'block', fontSize: '13px', fontWeight: 700, marginBottom: '4px' }}>¿Por qué cancelas? Nos ayuda a mejorar</label>
      <select id="motivo-cancelar" value={motivo} onChange={(e) => setMotivo(e.target.value)} disabled={guardando}
        style={{ width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '10px', fontSize: '14px', fontFamily: 'inherit', marginBottom: '8px', background: '#fff' }}>
        <option value="">Elige un motivo</option>
        {MOTIVOS.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
      <textarea value={detalle} onChange={(e) => setDetalle(e.target.value)} disabled={guardando} rows={2} maxLength={250}
        placeholder="¿Algo más que quieras contarnos? (opcional)" aria-label="Comentario opcional"
        style={{ width: '100%', boxSizing: 'border-box', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '10px', fontSize: '14px', fontFamily: 'inherit', resize: 'vertical', marginBottom: '12px' }} />
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <button onClick={() => setAbierto(false)} disabled={guardando} style={{ ...btn, background: 'var(--color-primario,#6D28D9)', color: '#fff', border: 'none' }}>Mejor me quedo</button>
        <button onClick={cancelar} disabled={guardando || !motivo} style={{ ...btn, color: motivo ? '#B91C1C' : '#9CA3AF', borderColor: motivo ? '#FCA5A5' : '#E5E7EB' }}>
          {guardando ? 'Cancelando…' : 'Sí, cancelar mi plan'}
        </button>
      </div>
    </div>
  );
}
